import { render, staticRenderFns } from "./IntegrationLayout.vue?vue&type=template&id=5a7d97d9&"
import script from "./IntegrationLayout.vue?vue&type=script&lang=js&"
export * from "./IntegrationLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports